import { render, staticRenderFns } from "./legalDeclarationUS.vue?vue&type=template&id=96ae80aa&scoped=true"
import script from "./legalDeclarationUS.vue?vue&type=script&lang=js"
export * from "./legalDeclarationUS.vue?vue&type=script&lang=js"
import style0 from "./legalDeclarationUS.vue?vue&type=style&index=0&id=96ae80aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ae80aa",
  null
  
)

export default component.exports